import React, { useEffect } from "react";
import "./style.scss";

const TelegramWidget = () => {
    useEffect(() => {
        const iframe = document.createElement("iframe");
        iframe.id = "tgw_67d02a0cf45bb7cccf0ac504";
        iframe.frameBorder = "0";
        iframe.scrolling = "no";
        iframe.width = "100%";
        iframe.height = "540px";
        iframe.setAttribute("horizontalScrolling", "no");
        iframe.setAttribute("verticalScrolling", "no");
        iframe.setAttribute("src", "https://tgwidget.com/channel/v2.0/?id=67d02a0cf45bb7cccf0ac504");

        const container = document.getElementById("telegram-widget-container");
        if (container) {
            container.appendChild(iframe);
        }
    }, []);

    return <div id="telegram-widget-container" className="telegram-widget" />;
};

export default TelegramWidget;
